export const DEFAULT_INTERVAL_COUNT = 12;
